// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ARXx","newExpiryDate":"styles_newExpiryDate__1OP0z","footer":"styles_footer__1bU4g"};